import React from 'react';
import { Grid } from '@mui/material';
import PropTypes from 'prop-types';
import { CommandPanels, withBaseEditor } from '../../BaseEditor';

function EditorRenderer({ getControl }) {
  return (
    <Grid container spacing={2}>
      <Grid item sm={2}>
        {getControl('code')}
      </Grid>
      <Grid item sm={5}>
        {getControl('name')}
      </Grid>
      <Grid item sm={5}>
        {getControl('province')}
      </Grid>
    </Grid>
  );
}

EditorRenderer.propTypes = {
  getControl: PropTypes.func.isRequired,
};

export default withBaseEditor(EditorRenderer, '/api/catalog/districts/', CommandPanels.catCommandPanel);
